import { WishListItemStoreType } from '@marriott/mi-store-utils';
import { WishListLandingModel } from '../../organisms/WishListLanding/WishListLanding.types';

type WishlistModelWithLegacyLabels = WishListLandingModel & {
  roomLabel?: string;
  guestsLabel?: string;
  adultsLabel?: string;
  childrenLabel?: string;
  lessThanLabel?: string;
  childAgeLabel?: string;
};

const isFlexibleSearchEnabled = (model?: WishListLandingModel): boolean =>
  model?.enableFlexibleSearch === true || model?.enableFlexibleSearch === 'true';

export const createWishlistsPayload = (updatedWishlists: WishListItemStoreType[] = []) =>
  updatedWishlists.map(
    ({ wishlistId, wishlistName, startDate, endDate, numberOfRooms, numberOfGuests, properties }) => ({
      id: wishlistId,
      name: wishlistName,
      startDate,
      endDate,
      numberOfRooms,
      numberOfGuests,
      properties: Array.isArray(properties) ? properties.map(property => property.propertyId) : [],
    })
  );

export const getWishlistDatePickerContextValue = (model?: WishListLandingModel, currentLocale?: string) => ({
  currentLocale,
  exactDatesTabText: model?.exactDatesTabText,
  flexibleTabText: model?.flexibleTabText,
  stayDates: model?.modalDate,
  dateModalHeader: model?.dateModalHeader,
  night: model?.night,
  nights: model?.nights,
  nightLabel: model?.night,
  weekdays: model?.weekdays,
  weekdaysLong: model?.weekdaysLong,
  months: model?.months,
  weekdaysShort: model?.weekdaysShort,
  monthsShort: model?.monthsShort,
  maxNumberOfNights: model?.maxNoOfFlexibleNights,
  clear: model?.flexibleDatesResetCta,
  resetSpecificDateCta: model?.resetSpecificDateCta,
  enableFlexibleSearch: isFlexibleSearchEnabled(model),
  datesSearchLabel: model?.modalDate,
  isTabbedSearchForm: true,
  flexibleDatesToggle: false,
  submitSpecificDateCta: model?.submitSpecificDateCta,
  submitSpecificDateCtaMobile: model?.submitSpecificDateCta,
  cancel: model?.cancel,
  flexibleDatesSubmitCta: model?.flexibleDatesSubmitCta,
  firstDayOfWeek: model?.firstDayOfWeek,
  yearLabel: model?.yearLabel,
  howManyNightsText: model?.howManyNightsText,
});

export const getWishlistRoomsAndGuestsContextValue = (model?: WishListLandingModel) => {
  const labels = model as WishlistModelWithLegacyLabels | undefined;

  return {
    roomsAndGuestEybrowText: model?.roomsAndGuestEyebrowText,
    roomsAndGuestEyebrowText: model?.roomsAndGuestEyebrowText,
    rooms: model?.rooms || model?.roomsLabel || '',
    room: model?.room || labels?.roomLabel || '',
    guests: model?.guests || labels?.guestsLabel || '',
    guest: model?.guest || model?.guestLabel || '',
    roomListLabel: model?.roomListLabel || Array.from({ length: 9 }, (_, index) => index + 1).join(', '),
    roomsAndGuestsResetCta: model?.roomsAndGuestsResetCta,
    maxGuestPerRoom: model?.maxGuestPerRoom,
    adults: model?.adults || labels?.adultsLabel || '',
    children: model?.children || labels?.childrenLabel || '',
    done: model?.roomsAndGuestDoneCta || model?.flexibleDatesSubmitCta,
    roomsAndGuestsDoneCta: model?.roomsAndGuestDoneCta || model?.flexibleDatesSubmitCta,
    roomsAndGuestAdultHelperText: model?.roomsAndGuestAdultHelperText,
    roomsAndGuestChildHelperText: model?.roomsAndGuestChildHelperText,
    maxChildAgeLabel: model?.maxChildAgeLabel || String(model?.maxChildAge ?? 17),
    ageBasedRatesLabel: model?.ageBasedRatesLabel,
    smallerThanOneLabel: model?.smallerThanOneLabel || labels?.lessThanLabel,
    isTabbedSearchForm: true,
    hideDestination: false,
    unitOfRoom: '',
    childAgeRequired: model?.childAgeRequired || labels?.childAgeLabel || '',
  };
};

const formatLocalDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getTodayAndTomorrowDates = () => {
  const today = new Date();
  const todayDate = formatLocalDate(today);
  const tomorrowDateObj = new Date(today);
  tomorrowDateObj.setDate(tomorrowDateObj.getDate() + 1);
  const tomorrowDate = formatLocalDate(tomorrowDateObj);

  return { todayDate: todayDate, tomorrowDate: tomorrowDate };
};
